import { render, staticRenderFns } from "./CookingPage.vue?vue&type=template&id=5a8b7bd8&"
import script from "./CookingPage.vue?vue&type=script&lang=js&"
export * from "./CookingPage.vue?vue&type=script&lang=js&"
import style0 from "./CookingPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports